<script async setup lang="ts">
import AccoItemRating from '@/components/AccosFilterPage/FilterResults/AccoItem/SubComponent/AccoItemRating.vue'
import type { IAccoItem } from '@/composables/Interfaces/apiInterfaces'
import { mapAccoItem } from '@/store/filter.store'
import { computed } from 'vue'
import CartAccoItemDelete from './CartAccoItemDelete.vue'

const props = defineProps<{
  item: IAccoItem
}>()

const accoItem = computed(() => mapAccoItem(props.item))
</script>

<template>
  <div class="relative flex w-full flex-row">
    <div class="flex flex-col">
      <div class="relative flex items-center gap-1">
        <AccoItemRating :is-superior="accoItem.isSuperior" :rating="accoItem.rating" :symbol-class="accoItem.symbolClass" />
      </div>
      <div class="font-semibold">{{ accoItem.companyName }}</div>
      <div class="text-sm font-normal">{{ accoItem.location }}</div>
    </div>
    <div class="ml-auto">
      <CartAccoItemDelete :cid="accoItem.companyId"></CartAccoItemDelete>
    </div>
  </div>
  <div class="my-2 border-b border-white last:hidden"></div>
</template>
